import React, { useState } from 'react';

import FilterContext from './filter.context';

const FilterState = props => {

    const[filterDetails, setFilterDetails] = useState({});

    return (<FilterContext.Provider value={{ filterDetails, setFilterDetails }}>{props.children}</FilterContext.Provider>);
}

export default FilterState;